import strings from "./strings.json";
import { useAppStore } from "../../store/app";

type Lang = "en" | "nl";
export type StringKey = keyof typeof strings;

// No ICU plural syntax — plural variants are separate keys (_one / _other)
// chosen in code, which keeps this hook trivial (spec §14.3).
export function useT() {
  const lang = useAppStore((s) => s.language) as Lang;
  return (key: StringKey, vars?: Record<string, string | number>) => {
    let str: string = strings[key]?.[lang] ?? strings[key]?.["en"] ?? key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        str = str.replaceAll(`{${k}}`, String(v));
      });
    }
    return str;
  };
}
